module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('main', {
    staticClass: "z-depth-3"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header z-depth-4"
  }, [_c('div', {
    attrs: {
      "id": "line-top"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reservas hide-on-small-only"
  }, [_c('div', {
    staticClass: "card z-depth-4"
  }, [_c('div', {
    staticClass: "card-content brown-text hoverable"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_c('i', {
    staticClass: "tiny material-icons"
  }, [_vm._v("hotel")]), _vm._v("Reservas")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "tiny material-icons"
  }, [_vm._v("phone")]), _vm._v("(33)3263-3883")])]), _vm._v(" "), _c('div', {
    staticClass: "card-action"
  }, [_c('a', {
    attrs: {
      "href": "#/reservas"
    }
  }, [_vm._v("Click aqui")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container valign-wrapper"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_c('div', {
    staticClass: "col s2"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    }
  }, [_c('img', {
    attrs: {
      "width": "100",
      "height": "100",
      "src": require("./img/logo.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 center-align hide-on-small-only titulo-principal"
  }, [_c('h4', {
    staticClass: "brown-text darken-4"
  }, [_vm._v("Resplendor Center Hotel")])])])]), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "nav-wrapper container"
  }, [_c('a', {
    staticClass: "button-collapse",
    attrs: {
      "href": "#",
      "data-activates": "nav-mobile"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])]), _vm._v(" "), _c('ul', {
    staticClass: "left hide-on-med-and-down"
  }, [_c('li', {
    staticClass: "nav-home"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-hotel"
  }, [_c('a', {
    attrs: {
      "href": "#/hotel"
    }
  }, [_vm._v("O Hotel")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-acom"
  }, [_c('a', {
    attrs: {
      "href": "#/acomodacoes/suite-nupcias"
    }
  }, [_vm._v("Acomodações")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-serv"
  }, [_c('a', {
    attrs: {
      "href": "#/servicos"
    }
  }, [_vm._v("Serviços")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-cafe"
  }, [_c('a', {
    attrs: {
      "href": "#/cafe"
    }
  }, [_vm._v("Café da Manhã")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-reser"
  }, [_c('a', {
    attrs: {
      "href": "#/reservas"
    }
  }, [_vm._v("Reservas")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-resp"
  }, [_c('a', {
    attrs: {
      "href": "#/resplendor"
    }
  }, [_vm._v("Resplendor")])])]), _vm._v(" "), _c('ul', {
    staticClass: "side-nav",
    attrs: {
      "id": "nav-mobile"
    }
  }, [_c('li', {
    staticClass: "nav-home"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-hotel"
  }, [_c('a', {
    attrs: {
      "href": "#/hotel"
    }
  }, [_vm._v("O Hotel")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-acom"
  }, [_c('a', {
    attrs: {
      "href": "#/acomodacoes/suite-nupcias"
    }
  }, [_vm._v("Acomodações")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-serv"
  }, [_c('a', {
    attrs: {
      "href": "#/servicos"
    }
  }, [_vm._v("Serviços")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-cafe"
  }, [_c('a', {
    attrs: {
      "href": "#/cafe"
    }
  }, [_vm._v("Café da Manhã")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-reser"
  }, [_c('a', {
    attrs: {
      "href": "#/reservas"
    }
  }, [_vm._v("Reservas")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-resp"
  }, [_c('a', {
    attrs: {
      "href": "#/resplendor"
    }
  }, [_vm._v("Resplendor")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-footer z-depth-3"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row logo_rodape"
  }, [_c('div', {
    staticClass: "col s2 m2 l2"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    }
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "width": "80",
      "height": "80",
      "src": require("./img/logo.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col s4 m5 l5 text-rodape flow-text"
  }, [_c('p', {
    staticClass: "hide-on-small-only"
  }, [_vm._v("Av. Olegário Maciel N.364 B")]), _vm._v(" "), _c('p', {
    staticClass: "hide-on-small-only"
  }, [_vm._v("Centro, Resplendor MG ")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "tiny material-icons"
  }, [_vm._v("phone")]), _vm._v("(33)3263-3883")])]), _vm._v(" "), _c('div', {
    staticClass: "col s2 m1 l1"
  }, [_c('a', {
    staticClass: "brown-text",
    attrs: {
      "href": "https://www.facebook.com/pages/Resplendor-Center-Hotel/405922639457098?fref=ts",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "medium ion-logo-facebook"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col s2 m1 l1"
  }, [_c('a', {
    staticClass: "brown-text",
    attrs: {
      "href": "https://www.instagram.com/resplendorcenterhotel/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "medium ion-logo-instagram"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col s2 m3 l3 right"
  }, [_c('a', {
    attrs: {
      "href": "http://netzachsolutions.com.br",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "width": "110",
      "height": "110",
      "src": require("./img/SmallLogo.png")
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8a0b7db4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a0b7db4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 87
// module chunks = 0